import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
} from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { ReportsService } from "../services/reports.service";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import * as moment from "moment";
import { MatTableExporterDirective } from "mat-table-exporter";

@Component({
  selector: "app-user-defined-report",
  templateUrl: "./user-defined-report.component.html",
  styleUrls: ["./user-defined-report.component.scss"],
})
export class UserDefinedReportComponent implements OnInit, AfterViewInit {
  currentUser: any;
  showSpinner = false;
  reportData: any[] = [];
  clientData: any[] = [];
  selectedReport: any = null;
  ToDate: any = new Date();
  FromDate: any = new Date();
  data: any = "";
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTableExporterDirective) exporter: MatTableExporterDirective;

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private MasterService: MasterService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("User-Defined Report");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.Get_User_Defined_Reports();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

isDateInRange(row: any): boolean {
  if (!row.PaymentDate || row.PaymentDate === 'Total') return false;
  // Try to parse PaymentDate as DD-MM-YYYY or DD/MM/YYYY
  const paymentDate = moment(row.PaymentDate, ['DD-MM-YYYY', 'DD/MM/YYYY'], true);
  if (!paymentDate.isValid()) return false;
  const from = moment(this.FromDate);
  const to = moment(this.ToDate);
  return paymentDate.isSameOrAfter(from, 'day') && paymentDate.isSameOrBefore(to, 'day');
}
isTotalRow(row: any): boolean {
  return row.PaymentDate === 'Total';
}
changeHeaderTitle() {
    this.dataSharingService.HeaderTitle.next(this.selectedReport.Report_Name || "User-Defined Report");
}
  Get_User_Defined_Reports() {
    this.showSpinner = true;
    const requestData = {};
    this.reportsService
      .Get_User_Defined_Reports({ JSON: JSON.stringify(requestData) })
      .subscribe((response: any) => {
        if (response.length > 0) {
          this.reportData = response;
        }
        this.showSpinner = false;
      });
  }

  onReportSearch() {
        this.showSpinner = true;

    const params = [];

    if (this.selectedReport?.From_Date) {
      const formattedFromDate = moment(this.FromDate).format("YYYY-MM-DD");
      params.push(`@FromDate = '${formattedFromDate}'`);
    }

    if (this.selectedReport?.To_Date) {
      const formattedToDate = moment(this.ToDate).format("YYYY-MM-DD");
      params.push(`@To = '${formattedToDate}'`);
    }

    if (this.selectedReport?.Is_loginUserId) {
      params.push(`@LoginUserId = ${this.currentUser.userId}`);
    }

    this.data = `EXEC ${this.selectedReport.Stored_Procedures_Name} ${params.join(", ")}`;
    console.log("Executing Query:", this.data);

    this.reportsService
      .Client_Dynamic_Report({ SpExecute: this.data })
      .subscribe((res: any) => {
        this.clientData = res;
        if (res && res.length > 0) {
          this.displayedColumns = Object.keys(res[0]);
          this.dataSource = new MatTableDataSource(res);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else {
          this.displayedColumns = [];
          this.dataSource = new MatTableDataSource([]);
        }
        this.showSpinner = false;

      });
  }

  exportToExcel() {
    if (!this.dataSource.data || this.dataSource.data.length === 0) {
      this.snackBar.open("No data available to export", "Close", this.configSuccess);
      return;
    }
    this.exporter.exportTable("xlsx", { fileName: "user-defined-report" });
  }
    applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
